<template>
  <div class="im-right-list-search">
    <el-input class="m-search-input" v-model="search" placeholder="搜索" prefix-icon="el-icon-search" size="mini"></el-input>
    <span class="search-add" @click="handleOpenWindow"><i class="el-icon-plus"></i></span>
  </div>
</template>

<script>
export default {
  name: 'ConversationSearch',
  components: {},
  props: {
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleOpenWindow () {
      this.$store.dispatch('changeImWinCreateTeamVisibleAction', !this.$store.state.imWinCreateTeamVisible)
    }
  }
}
</script>

<style lang="stylus" scoped>
.im-right-list-search {
  display: flex;
  padding: 12px;
  position: relative;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
  gap: 10px;
}
.search-add {
  padding: 5px;
  background-color: rgb(234 234 234);
  border-radius: 5px;
}
.m-search-input >>> .el-input__inner {
  height: 25px;
  line-height: 25px;
  background-color: #eaeaea;
}
.m-search-input >>> .el-input__inner:focus {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ConversationSearch.vue